// extracted by mini-css-extract-plugin
module.exports = {"TagInput":"TagInput_TagInput__3Mlyv","Header":"TagInput_Header__30c6n","Container":"TagInput_Container__3ZiuM","Subtitle":"TagInput_Subtitle__3zBv5"};